import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUrls } from 'src/app/api-urls.constants';
import { TranslationService } from 'src/metronic/core/_base/layout';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
import { AlertData } from './models/alert.model';
import { EnrollmentData, EnrollmentDTO, EnrollmentDataDTO } from './models/enrollment-data.model';
import { Enrollment } from './models/enrollment.model';
import { SemesterName } from './models/semester-name.model';

@Injectable({
  providedIn: 'root'
})
export class HomePageService {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService
  ) { }

  private readonly enrollmentDataSub$ = new Subject<EnrollmentData>();

  getActiveAlerts(language: LanguageType): Observable<AlertData[]> {
    return of([]);
    // left for Michał to get started
    // return this.getMockAlerts(language);
    // return this.http.get<AlertData[]>(ApiUrls.ActiveHomeAlerts, { params: { lang: language } });
  }

  getActiveEnrollments(language: LanguageType): Observable<Enrollment[]> {
    return this.getEnrollments(true, language);
  }

  getFutureEnrollments(language: LanguageType): Observable<Enrollment[]> {
    return this.getEnrollments(false, language);
  }

  initEnrollmentData(): void {
    this.http
      .get<EnrollmentDataDTO>(ApiUrls.EnrollmentData)
      .pipe(
        map((enrollmentData: EnrollmentDataDTO) => {
          if (enrollmentData.startOrEndDate == null) {
            return {
              ...enrollmentData,
              startOrEndDate: null,
              semesterName: null
            };
          }

          return {
            ...enrollmentData,
            startOrEndDate: new Date(enrollmentData.startOrEndDate).toLocaleDateString(this.translationService.getCurrentLanguage()),
            semesterName: this.translationService.getInstantTranslation(SemesterName[enrollmentData.semesterNameIdentifier])
          };
        })
      )
      .subscribe(d => this.enrollmentDataSub$.next(d));
  }

  getEnrollmentData(): Observable<EnrollmentData> {
    return this.enrollmentDataSub$.asObservable();
  }

  private getEnrollments(shouldFetchActiveEnrollments: boolean, language: LanguageType) {
    return this.http
      .get<EnrollmentDTO[]>(
        shouldFetchActiveEnrollments ? ApiUrls.ActiveEnrollments : ApiUrls.FutureEnrollments, { params: { lang: language } }
      )
      .pipe(
        map((enrollmensDTOs: EnrollmentDTO[]) => enrollmensDTOs.map(enrollmenDTO => new Enrollment(enrollmenDTO)))
      );
  }

  // left for Michał for reference
  private getMockAlerts(language: LanguageType): Observable<AlertData[]> {
    const mockAlertsPl: AlertData[] = [
      {
        language: LanguageType.Polish,
        text: `
        W związku z zagrożeniem epidemiologicznym COVID-19 Dział Rekrutacji obsługuje kandydatów na studia w ograniczonym trybie:<br>
          <br>
          <ul>
            <li>
              za pośrednictwem poczty elektronicznej – <a href="mailto:rekrutacja@pja.edu.pl" target="_blank">rekrutacja@pja.edu.pl</a> oraz telefonicznie:
              <ul>
                <li>od poniedziałku do piątku w godzinach 9:00-17:00.</li>
              </ul>
            </li>
            <li>
              osobiście:
              <ul>
                <li>Poniedziałki 14.00 – 16.00</li>
                <li>Od wtorku do piątku w godzinach 10.00 – 12.00 oraz 14.00 – 16.00</li>
              </ul>
            </li>
          </ul>
          <br>
          Kandydatom po wejściu na uczelnie mierzona jest temperatura.<br>
          Kandydaci wchodzą pojedynczo, dezynfekują ręcę i obowiązkowo zasłaniają nos i usta.
        `
      },
      {
        language: LanguageType.Polish,
        text: 'Jakiś testowy <b>alert</b> z przykładowymi <a href="https://pja.edu.pl">tagami html</a><br><br> nowa linia <br><br> Lista:<br><ul><li>test 1</li><li>test 2</li></ul>'
      }
    ];

    const mockAlertsEn: AlertData[] = [
      {
        language: LanguageType.English,
        text: `
          Due to the epidemiological threat of COVID-19, the Recruitment Department accept candidates for studies in a limited manner:<br>
          <br>
          <ul>
            <li>
            through e-mail – <a href="mailto:rekrutacja@pja.edu.pl" target="_blank">rekrutacja@pja.edu.pl</a> and by telephone:
              <ul>
                <li>from Monday to Friday between 9:00-17:00.</li>
              </ul>
            </li>
            <li>
            personally:
              <ul>
                <li>Monday 14.00 – 16.00</li>
                <li>From Tuesday to Friday between 10.00 – 12.00 and 14.00 – 16.00</li>
              </ul>
            </li>
          </ul>
          <br>
          Candidates enter the University one at a time, disinfect their hands and cover their nose and mouth. The temperature of the candidates is measured.
        `
      },
      {
        language: LanguageType.English,
        text: 'Some test <b>alert</b> with examples of <a href="https://pja.edu.pl">html tags</a> <br><br> new line <br><br> List:<br><ul><li>test 1</li><li>test 2</li></ul>'
      }
    ];

    if (language === LanguageType.Polish) {
      return of(mockAlertsPl);
    }
    else {
      return of(mockAlertsEn);
    }
  }
}
